var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',_vm._l((_vm.activeRoutes),function(item){return _c('v-btn',{key:item.title,attrs:{"color":"secondary darken-2 px-4 mt-5","to":item.to,"dark":""},domProps:{"textContent":_vm._s(item.title)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }